import './AdminDashboardView.scss';
import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import { AdminDashboardNavigation } from './AdminDashboardNavigation';
import { AdminDashboardTabs } from './AdminDashboardTabs';
import React from 'react';
export const AdminDashboardView = () => React.createElement("div", { className: 'admin-dashboard' },
    React.createElement("div", { className: 'admin-header' },
        React.createElement("div", { className: 'h1' }, ADMIN_DASHBOARD_COPY.AROVY_ADMIN_PANEL),
        React.createElement(AdminDashboardNavigation, null)),
    React.createElement("div", { className: 'admin-content' },
        React.createElement(AdminDashboardTabs, { id: 'admin-tabs' })));
